module.exports = "<div class=\"content\">\n  <!-- Dynamically Insert Content Here -->\n  <%= data.content %>\n  <button class='close'></button>\n</div>\n<div class=\"overlay\"></div>";
